import { render, staticRenderFns } from "./List-carteira-vacinacao-colaborador.vue?vue&type=template&id=0e040f33&"
import script from "./List-carteira-vacinacao-colaborador.vue?vue&type=script&lang=js&"
export * from "./List-carteira-vacinacao-colaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports